import React from "react";
import Hero from "../components/Hero";
import StatsSection from "../components/StatsSection";
import Methodology from "../components/Methodology";
import PreviousTips from "../components/PreviousTips";
import AboutTipster from "../components/AboutTipster";
import Testimonials from "../components/Testimonials";
import MembershipPreview from "../components/MembershipPreview";

const Home = () => {
  return (
    <>
      <Hero />
      <StatsSection />
      <Methodology />
      <AboutTipster />
      <PreviousTips limit={30} />
      <Testimonials />
      <MembershipPreview />
    </>
  );
};

export default Home;
